import { KeySet, stringListToKeySet } from '@tableau/data-structures';
import { MutableParamValuesMap, ParamValuesMap } from './ParamValuesMap';

export function searchToParamValuesMap(search: string): MutableParamValuesMap {
  const paramValuesMap: MutableParamValuesMap = {};
  if (search.length > 0) {
    if (search[0] === '?') {
      search = search.slice(1);
    }
    const clauses = search.split('&');
    for (const clause of clauses) {
      const parts = clause.split('=');
      if (parts.length > 0) {
        const param = decodeURIComponent(parts[0]);
        paramValuesMap[param] = parts[1] ? parts[1].split(',').map(decodeURIComponent) : [];
      }
    }
  }
  return paramValuesMap;
}

export function paramValuesMapToSearch(paramValuesMap: ParamValuesMap): string {
  const searchClauses = [];



  for (const param in paramValuesMap) {
    if (Object.prototype.hasOwnProperty.call(paramValuesMap, param)) {
      const encodedParam = encodeURIComponent(param);
      const values = paramValuesMap[param];
      if (values && values.length > 0) {
        searchClauses.push(`${encodedParam}=${values.join(',')}`);
      } else {
        searchClauses.push(encodedParam);
      }
    }
  }
  if (searchClauses.length > 1) {
    return `?${searchClauses.join('&')}`;
  } else if (searchClauses.length === 1) {
    return `?${searchClauses[0]}`;
  } else {
    return '';
  }
}

export function addParamValue(paramValuesMap: MutableParamValuesMap, param: string, value: string, encode = true) {
  const values = paramValuesMap[param];

  if (encode) {
    value = encodeURIComponent(value);
  }

  if (!values) {
    paramValuesMap[param] = [value];
  } else {
    if (values.indexOf(value) === -1) {
      paramValuesMap[param] = [...values, value];
    }
  }
}

export function removeParamValue(paramValuesMap: MutableParamValuesMap, param: string, value: string) {
  const values = paramValuesMap[param];
  if (values) {
    paramValuesMap[param] = values.filter(v => v !== value);
    if (paramValuesMap[param].length === 0) {
      delete paramValuesMap[param];
    }
  }
}

export function setParamValues(paramValuesMap: MutableParamValuesMap, param: string, values: ReadonlyArray<string>, encode = true) {
  if (encode) {
    values = values.map(encodeURIComponent);
  }

  paramValuesMap[param] = values;
  if (paramValuesMap[param].length === 0) {
    delete paramValuesMap[param];
  }
}

export function getParamValuesAsSet(search: string, param: string): KeySet {
  const paramValuesMap = searchToParamValuesMap(search);
  return stringListToKeySet(paramValuesMap[param]);
}

// Only take the first id for the param until Multi-Select Filtering is supported
export function getFirstParamValueAsSet(search: string, param: string): KeySet {
  const firstParamValue = getSingleParamValue(search, param);
  return stringListToKeySet(firstParamValue ? [firstParamValue] : []);
}

export function getSingleParamValue(search: string, param: string): string {
  const paramValuesMap = searchToParamValuesMap(search);
  return paramValuesMap[param] ? paramValuesMap[param][0] : '';
}
